import emailjs from "emailjs-com";

export const sendEmail = (templateId, templateParams) => {
  const _templateId = templateId === "order" ?
    process.env.REACT_APP_EMAIL_JS_ORDER_TEMPLATE_ID :
    process.env.REACT_APP_EMAIL_JS_CONTACT_TEMPLATE_ID;

  emailjs
    .send(
      "gmail",
      _templateId,
      templateParams,
      process.env.REACT_APP_EMAIL_JS_USER_ID
    )
    .then(
      (result) => {
        console.log(result.text);
      },
      (error) => {
        console.error(error.text);
      }
    );
};